import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';

import Keycloak from 'keycloak-js';

import { AnalyticsProvider } from 'Analytics';

import { PermissionProvider } from 'Authorized';

import ProgressBar from 'components/ProgressBar';
import Toaster from 'components/Toaster';

import { TOKEN_SESSION_KEY } from 'features/Auth/CONSTANTS';

import Layout from 'layout';

import { saveState } from 'Utilities/LocalStorage';

const firebaseConfig = {
	apiKey: 'AIzaSyAItbrAiJwtZfo091zjcQS5Eljid35N_qQ',
	authDomain: 'bp-crm-16dce.firebaseapp.com',
	databaseURL: 'https://bp-crm-16dce.firebaseio.com',
	projectId: 'bp-crm-16dce',
	storageBucket: 'bp-crm-16dce.appspot.com',
	messagingSenderId: '173880852236',
	appId: '1:173880852236:web:13150a0884ff8ba9f3d329',
	measurementId: 'G-C5GXEFWG4G',
};

const App: React.FC = () => {
	const keycloak = new Keycloak('/keycloak.json');
	const initOptions = { pkceMethod: 'S256' };
	return (
		<AnalyticsProvider value={{ appName: 'crm-react', firebaseConfig: firebaseConfig }}>
			<ReactKeycloakProvider
				authClient={keycloak}
				initOptions={initOptions}
				onTokens={({ token }) => saveState(TOKEN_SESSION_KEY, token)}
				LoadingComponent={<ProgressBar loading />}>
				<PermissionProvider>
					<Layout />
					<Toaster />
				</PermissionProvider>
			</ReactKeycloakProvider>
		</AnalyticsProvider>
	);
};

export default App;
